import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServicesCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative bg-gradient-to-br from-[#1a1a2e] to-[#16213e] rounded-3xl p-12 lg:p-16 overflow-hidden">
          {/* Background Decorations */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF6B6B]/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#4ECDC4]/10 rounded-full blur-3xl"></div>
          
          {/* Geometric Elements */}
          <div className="absolute top-10 right-20 w-4 h-4 bg-[#FF6B6B] rounded-full"></div>
          <div className="absolute bottom-20 left-20 w-3 h-3 bg-[#4ECDC4] rounded-full"></div>
          <div className="absolute top-1/2 right-10 w-20 h-20 border border-white/10 rounded-2xl rotate-12"></div>

          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-rocket-2-line text-[#FF6B6B]"></i>
              <span className="text-white/80 text-sm font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {t('servicesPage.ctaBadge')}
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {t('servicesPage.ctaTitle')}
              <br />
              <span className="bg-gradient-to-r from-[#FF6B6B] via-[#FF8E53] to-[#4ECDC4] bg-clip-text text-transparent">
                {t('servicesPage.ctaTitleHighlight')}
              </span>
              <br />
              {t('servicesPage.ctaTitleEnd')}
            </h2>

            <p className="text-xl text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed">
              {t('servicesPage.ctaDesc')}
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/contact"
                className="group px-8 py-4 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white rounded-2xl font-semibold hover:shadow-2xl hover:shadow-[#FF6B6B]/30 transition-all cursor-pointer whitespace-nowrap flex items-center gap-3"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {t('servicesPage.ctaPrimary')}
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
              
              <Link
                to="/contact"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-2xl font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap border border-white/20 flex items-center gap-3"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                <i className="ri-phone-line"></i>
                {t('servicesPage.ctaSecondary')}
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 flex flex-wrap justify-center gap-8">
              <div className="flex items-center gap-2 text-white/60">
                <i className="ri-shield-check-fill text-[#4ECDC4]"></i>
                <span className="text-sm">{t('servicesPage.trustIndicator1')}</span>
              </div>
              <div className="flex items-center gap-2 text-white/60">
                <i className="ri-time-line text-[#FF6B6B]"></i>
                <span className="text-sm">{t('servicesPage.trustIndicator2')}</span>
              </div>
              <div className="flex items-center gap-2 text-white/60">
                <i className="ri-map-pin-line text-[#FF8E53]"></i>
                <span className="text-sm">{t('servicesPage.trustIndicator3')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
